module.exports = __webpack_public_path__ + "static/media/LogoDE.e0a37d98.svg";